function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 16C4.39397 16 4.78407 15.9224 5.14805 15.7716C5.51203 15.6209 5.84274 15.3999 6.12132 15.1213C6.3999 14.8427 6.62087 14.512 6.77164 14.1481C6.9224 13.7841 7 13.394 7 13C7 13.7956 7.31607 14.5587 7.87868 15.1213C8.44129 15.6839 9.20435 16 10 16C10.7956 16 11.5587 15.6839 12.1213 15.1213C12.6839 14.5587 13 13.7956 13 13C13 13.7956 13.3161 14.5587 13.8787 15.1213C14.4413 15.6839 15.2044 16 16 16C16.7957 16 17.5587 15.6839 18.1213 15.1213C18.6839 14.5587 19 13.7956 19 13C19 13.7956 19.3161 14.5587 19.8787 15.1213C20.4413 15.6839 21.2044 16 22 16C22.7957 16 23.5587 15.6839 24.1213 15.1213C24.6839 14.5587 25 13.7956 25 13C25 19.6276 19.6276 25 13 25C6.3724 25 1 19.6276 1 13C1 13.7956 1.31607 14.5587 1.87868 15.1213C2.44129 15.6839 3.20435 16 4 16ZM15.4 6.4C15.4 7.03652 15.1471 7.64697 14.6971 8.09706C14.247 8.54714 13.6365 8.8 13 8.8C12.3635 8.8 11.753 8.54714 11.3029 8.09706C10.8529 7.64697 10.6 7.03652 10.6 6.4C10.6 5.074 13 1 13 1C13 1 15.4 5.074 15.4 6.4Z",
  fill: "white",
  stroke: "#4285F4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgQDen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQDen);
export default __webpack_public_path__ + "static/media/Q_den.b8f8bbf0.svg";
export { ForwardRef as ReactComponent };